export const FOOD_PAYMENT_EMOJIS = Object.freeze([
  "🍔",
  "🍟",
  "🍪",
  "🍰",
  "🍦",
  "🍩",
  "🍒",
  "🍭",
]);

const repeat = (emoji, count) => Array.from({ length: count }, () => emoji);

export const getDonationEffectSpec = (amount, paymentEmoji) => {
  if (FOOD_PAYMENT_EMOJIS.includes(paymentEmoji)) {
    return {
      leadingEmojis: [
        ...repeat(paymentEmoji, 2),
        ...repeat("🪙", 2),
      ],
      dollarCount: 0,
    };
  }

  const cents = Math.round((Number(amount) || 0) * 100);
  if (cents >= 100000) {
    return {
      leadingEmojis: [
        ...repeat("🤑", 50),
        ...repeat("💵", 50),
        ...repeat("💸", 50),
        ...repeat("💰", 50),
        ...repeat("💎", 20),
        ...repeat("💳", 20),
      ],
      dollarCount: 2000,
    };
  }
  if (cents >= 50000) {
    return {
      leadingEmojis: [
        ...repeat("🤑", 50),
        ...repeat("💵", 50),
        ...repeat("💸", 50),
        ...repeat("💰", 50),
        ...repeat("💎", 10),
      ],
      dollarCount: 1000,
    };
  }
  if (cents >= 30000) {
    return {
      leadingEmojis: [
        ...repeat("🤑", 50),
        ...repeat("💵", 50),
        ...repeat("💸", 50),
        ...repeat("💰", 50),
      ],
      dollarCount: 600,
    };
  }
  if (cents >= 10000) {
    return {
      leadingEmojis: [
        ...repeat("🤑", 30),
        ...repeat("💵", 30),
        ...repeat("💸", 30),
        ...repeat("💰", 10),
      ],
      dollarCount: 300,
    };
  }
  if (cents >= 8000) {
    return {
      leadingEmojis: [
        ...repeat("🤑", 30),
        ...repeat("💵", 30),
        ...repeat("💸", 30),
      ],
      dollarCount: 100,
    };
  }
  if (cents >= 6000) {
    return {
      leadingEmojis: [
        ...repeat("🤑", 20),
        ...repeat("💵", 20),
        ...repeat("💸", 20),
      ],
      dollarCount: 80,
    };
  }
  if (cents >= 4000) {
    return {
      leadingEmojis: [
        ...repeat("🤑", 20),
        ...repeat("💵", 10),
        ...repeat("💸", 10),
      ],
      dollarCount: 60,
    };
  }
  if (cents >= 2000) {
    return {
      leadingEmojis: [
        ...repeat("🤑", 20),
        ...repeat("💵", 10),
      ],
      dollarCount: 40,
    };
  }
  if (cents >= 1000) {
    return { leadingEmojis: repeat("🤑", 20), dollarCount: 30 };
  }
  if (cents >= 500) {
    return { leadingEmojis: repeat("🤑", 10), dollarCount: 20 };
  }
  if (cents >= 100) {
    return { leadingEmojis: repeat("🤑", 5), dollarCount: 10 };
  }
  return {
    leadingEmojis: [],
    dollarCount: 0,
  };
};

export const normalizeDonationLeadingEmojis = (emojis) => (
  Array.isArray(emojis)
    ? emojis.filter((emoji) => typeof emoji === "string" && emoji.trim()).slice(0, 240)
    : []
);
